/* eslint-disable */
import html2pdf from 'html2pdf.js';


export const pricingHelper = (item, selectedOptions) => {
  if (typeof displayCurrency(item) === 'object') {
    const country =
      sessionStorage.getItem('country')?.toLocaleLowerCase() || 'usa';
    return {
      ...item,
      [country]: item.priceOn
        ? selectedOptions?.[item.priceOn]?.id
          ? displayCurrency(item)[selectedOptions?.[item.priceOn]?.id]
          : 0
        : displayCurrency(item)[selectedOptions?.style?.id],
    };
  } else {
    return item;
  }
};

export const isOptionsObject = (item, selectedOptions) => {
  if (typeof item === 'object') {
    return item?.[selectedOptions?.style?.id];
  } else {
    return item;
  }
};

export const checkModelDisabled = (selectedStyle, selectedOptions) => {
  const { disabled } = selectedStyle || {};
  if (disabled) {
    const k = Object.keys(disabled)[0];
    return selectedOptions?.[k]?.id === disabled[k];
  }
  return false;
};

export const displayCurrency = (obj) => {
  const country = sessionStorage.getItem('country');
  if (country === 'USA') {
    return obj?.usa;
  } else if (country === 'CANADA') {
    return obj?.canada;
  }
  return obj?.usa;
};

// export const generatePDF = async (
//   parentPath,
//   output,
//   sizes,
//   callback = undefined,
// ) => {
//   const element = document.getElementById('dreamKitchen');
//   const { height } = document.body.getBoundingClientRect();

//   const [top, bottom] = sizes();

//   const opt = {
//     filename: `${parentPath}.pdf`,
//     image: { type: 'jpeg', quality: 0.98 },
//     html2canvas: { scale: 2 },
//     margin: [top, -350, bottom, 0],
//     jsPDF: {
//       format: [1400, height + window.innerHeight], // height + 700
//       unit: 'px',
//       orientation: 'p',
//     },
//   };

//   if (output === 'blob') {
//     const worker = await html2pdf()
//       .set(opt)
//       .from(element)
//       .toPdf()
//       .output('datauristring');

//     return worker;
//   }

//   await new html2pdf().set(opt).from(element).save();
//   callback(false);
// };
export const generatePDF = async (
  parentPath,
  output,
  sizes,
  callback = undefined,
) => {
  let targetElement = document.getElementById('cK').cloneNode(true);
  const updatedElement = document.getElementById('dK').innerHTML;

  targetElement.style.width = '1200px';

  const opt = {
    filename: `${parentPath}.pdf`,
    image: { type: 'jpeg', quality: 0.98 },
    margin: [0, -16, 0, 0],
    html2canvas: { scale: 1, width: 1120 },
    jsPDF: {
      format: 'a4',
      orientation: 'portrait',
    },
  };

  if (output === 'blob') {
    const worker = await new html2pdf()
      .from(targetElement)
      .set(opt)
      .toPdf()
      .get('pdf')
      .then(function (pdf) {
        targetElement.innerHTML = updatedElement;
        pdf.addPage();
      })
      .toContainer()
      .toCanvas()
      .toPdf()
      .output('datauristring');

    return worker;
  }

  await new html2pdf()
    .from(targetElement)
    .set(opt)
    .toPdf()
    .get('pdf')
    .then(function (pdf) {
      targetElement.innerHTML = updatedElement;
      pdf.addPage();
    })
    .toContainer()
    .toCanvas()
    .toPdf()
    .save();
  callback(false);
};

export const isDealer = (dealer) => {
  let dealerArray = ['dealer'];
  if (dealer) {
    return !!dealerArray.find((path) => path === dealer);
  }
  return false;
};
